import { Box, Text, HStack, VStack, IconStatusNew } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { FixedFeeRelatedTerm } from '../FixedFeeRelatedTerm';
import { ContractDate } from '../shared/ContractDate';
import { FixedFeeRowActions } from '../shared/FixedFeeRowActions';
import { HasRelatedTermFlag } from '../shared/HasRelatedTermFlag';
import { Observations } from '../shared/Observations';

import { FixedFeeTermDetailsProps } from '.';

interface DetailRowProps {
  label: string;
  value: React.ReactNode;
}

const DetailRow: React.FC<DetailRowProps> = ({ label, value }) => {
  return (
    <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
      <Text>{label}</Text>
      <Text textAlign="right">{value}</Text>
    </HStack>
  );
};

export const FixedFeeTermDetailsMobile: React.FC<FixedFeeTermDetailsProps> = ({
  fixedFeeTerm,
  fixedFeeTermDetailed,
}) => {
  return (
    <VStack
      px="inline.xxxs"
      pb="inline.xxxs"
      bg="neutral.white"
      borderTopRadius="md"
      space="stack.xxxs">
      <HStack justifyContent="space-between" alignItems="flex-start" space="inline.nano">
        <VStack space="inline.quarck" flex={1}>
          <HStack space="inline.quarck" alignItems="center">
            <Text variant="semibold">{fixedFeeTerm.term}</Text>
            <HasRelatedTermFlag hasRelatedTerm={!!fixedFeeTerm.relatedTerm} />
          </HStack>

          <IconStatusNew
            color={fixedFeeTerm.statusColor}
            icon={fixedFeeTerm.statusIcon}
            status={fixedFeeTerm.status}
          />
        </VStack>
        <FixedFeeRowActions feeTerm={fixedFeeTerm} />
      </HStack>

      <HStack space="inline.quarck" justifyContent="space-between" alignItems="center">
        <Text>{fixedFeeTerm.customerName}</Text>
        <Text color="neutral.medium" fontSize="xs">
          Conta de custódia {fixedFeeTerm.account}
        </Text>
      </HStack>

      <VStack space="stack.nano">
        <DetailRow label="Data de criação" value={fixedFeeTerm.createDateNormalized} />
        <Box h="1px" bg="neutral.lightest" />
        <DetailRow label="Taxa (%)" value={fixedFeeTerm.feeRate} />
        <Box h="1px" bg="neutral.lightest" />
        <DetailRow label="Exclusão de taxa" value={fixedFeeTerm.equityExclusion} />
        <Box h="1px" bg="neutral.lightest" />
        <DetailRow
          label="Data de contratação"
          value={
            <ContractDate
              waitingResponse={fixedFeeTerm.waitingResponse}
              contractDate={fixedFeeTerm.contractDateNormalized}
            />
          }
        />
        <Box h="1px" bg="neutral.lightest" />
        <DetailRow label="Patrimônio líquido" value={fixedFeeTerm.netWorth} />
      </VStack>

      <Box
        h="1px"
        bg={Utils.ColorToken.WithOpacity('brand.primary.principal', 'opacity.semitransparent')}
      />

      <VStack space="stack.xxxs">
        <VStack space="stack.quarck">
          <Text color="neutral.medium" fontSize="xs">
            Última atualização do canal
          </Text>
          <IconStatusNew
            color={fixedFeeTermDetailed.statusColor}
            icon={fixedFeeTermDetailed.statusIcon}
            status={fixedFeeTermDetailed.statusText}
          />
        </VStack>

        <Observations observations="" />

        <VStack space="stack.quarck">
          <Text color="neutral.medium" fontSize="xs">
            Evento
          </Text>
          <Text>{fixedFeeTerm.eventType}</Text>
        </VStack>
      </VStack>

      <FixedFeeRelatedTerm fixedFeeTerm={fixedFeeTerm} />
    </VStack>
  );
};
